export default __webpack_public_path__ + "static/media/blueticket.alt.34e79ce6.png";